export const screenSizeDefault = {
	width: 1280,
	height: 720
}